module.exports = __webpack_public_path__ + "img/resistance_resonator_reflection_type.320a8cca.svg";